import { render, staticRenderFns } from "./DroneTVWrapper.vue?vue&type=template&id=0d28965f&scoped=true&"
import script from "./DroneTVWrapper.vue?vue&type=script&lang=ts&"
export * from "./DroneTVWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./DroneTVWrapper.vue?vue&type=style&index=0&id=0d28965f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d28965f",
  null
  
)

export default component.exports